export const TOGGLE_SECONDARY_BAR = "TOGGLE_SECONDARY_BAR";
export const SET_SECONDARY_BAR_TYPE = "SET_SECONDARY_BAR_TYPE";

//For Sidebar 3
export const TOGGLE_SECONDARY_BAR_3 = "TOGGLE_SECONDARY_BAR_3";
export const SET_SECONDARY_BAR_TYPE_3 = "SET_SECONDARY_BAR_TYPE_3";
